import "./servicessection.css";
import { GoPencil } from "react-icons/go";
import { LuShirt } from "react-icons/lu";
import { FaRegComments } from "react-icons/fa";
import servImg1 from '../../Media/Photos Gallery/gal12.png';
import servImg2 from '../../Media/Photos Gallery/gal14.png';
import servImg3 from '../../Media/Photos Gallery/gal13.png';

const services = [
  {
    icon: <GoPencil />,
    title: "Bespoke Fashion Design",
    description:
      "Our bespoke fashion service is built around your individuality. From initial sketches to final fittings, we work closely with you to create custom garments that reflect your style, story, and silhouette—down to the very last stitch.",
    image: servImg1,
  },
  {
    icon: <LuShirt />,
    title: "Bridal & Event Wear",
    description:
      "Every special occasion deserves a signature look. Our bridal and event wear services deliver stunning, custom-tailored pieces that blend sophistication with personality—ensuring you feel confident and unforgettable on your big day.",
    image: servImg2,
  },
  {
    icon: <FaRegComments />,
    title: "Wardrobe Consultation",
    description:
      "We help clients build timeless, functional wardrobes that align with their personal style and lifestyle. Our consultations include color and body-type analysis, outfit planning, and expert advice to enhance your daily dressing experience.",
    image: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f",
  },
  // {
  //   icon: <HiOutlineCog6Tooth />,
  //   title: "Mass Production",
  //   description:
  //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec.",
  //   image: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f",
  // },
  // {
  //   icon: <RxRulerSquare />,
  //   title: "Pattern Making",
  //   description:
  //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec.",
  //   image: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f",
  // },
  // {
  //   icon: <CiGlobe />,
  //   title: "Fashion Branding",
  //   description:
  //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec.",
  //   image: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f",
  // },
];

export default function ServicesSection() {
  return (
    <section className="services-section">
      <div className="section-header">
        <h6 className="small-header">Our Services</h6>
        <h3>Fashion That Reflects Who You Are</h3>
      </div>
      <div className="services-grid">
        {services.map((service, index) => (
          <div
            key={index}
            className="service-card"
            style={{ backgroundImage: `url(${service.image})` }}
          >
            <div className="overlay">
              <div className="icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
